import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { TransportationTemperatureAdherenceService } from "./service/widget-transportation-temperature-adherence.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);
@Component({
  selector: "app-widget-transportation-temperature-adherence",
  templateUrl: "./widget-transportation-temperature-adherence.component.html",
  styleUrls: ["./widget-transportation-temperature-adherence.component.scss"],
  providers: [TransportationTemperatureAdherenceService]
})
export class WidgetTransportationTemperatureAdherenceComponent
  implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions;

  constructor(
    private translateService: TranslateService,
    private dataService: TransportationTemperatureAdherenceService
  ) { }

  ngAfterViewInit() {
    this.getTransferEndToEndSlaTrendData();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
      JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getTransferEndToEndSlaTrendData();
    }
  }

  ngOnInit() { }

  getTransferEndToEndSlaTrendData() {
    const options = {
      url: this.OPTIONS && this.OPTIONS.url ? this.OPTIONS.url : "",
      params: this.FILTERS
    };
    this.dataService
      .getTransferEndToEndSlaTrendData(options)
      .pipe(takeUntil(this.unsubscribe)).subscribe(chartData => {
        if (chartData.data && chartData.data.length) {
          this.chartOptions = this.dataService.createChart(
            chartData.data,
            this.OPTIONS
          );
        }
      });
  }
  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }
}
